<template>
  <div class="w-100" id="app">
    
    <webapp-header/>
    <router-view/>
    <webapp-footer/>
    
  </div>
</template>
<script>
// @ is an alias to /src\
import {mapState} from 'vuex'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  name: 'Home',
  data(){
      return{
        
      }
  },
  components: {
    'webapp-header':Header,
    'webapp-footer':Footer
  },
  computed:{
    ...mapState(['token'])
  },
  methods:{
    
  
  }
}
</script>
<style>

  /*BASE*/
  *,
  *::after,
  *::before{
      margin: 0;
      padding: 0;
      box-sizing: inherit;
      font-size: 1.5rem;
  }
  html{
      font-size: 62.5%;
  }

  /*REUSE*/
  h1{
    color:var(--Color-main-dark-2);
    font-size: 4rem!important;
    text-transform: uppercase;
    text-align: center;
    font-weight: var(--light);
    
  }
  h2{
    color:var(--Color-main-dark-2);
    font-size: 3rem!important;
    text-transform: uppercase;
    text-align: center;
    font-weight: var(--light);
  }
  h3{
    color:var(--Color-main-dark-2);
    font-size: 2.5rem!important;
    text-align: center;
    font-weight: var(--light);
  }
  button{
    font-size: 1.6rem!important;
  }


  #app{  
      box-sizing: border-box;
      font-family: var(--MainFont);
      font-weight: var(--main);
      /*font-size: 16px;*/
      line-height: 1.7;
      color: var(--Color-main-dark-1);
      padding: 3rem;
      font-size: var(--default-font-size);
         
      
  }
  

  :root{
    /*FONT*/

    --MainFont: 'Roboto', sans-serif;
    --heavy2:900;
    --heavy1:700;
    --medium:500;
    --main:400;
    --light:300;
    --default-font-size:1.6rem;
    --default-font-size-md:2.6rem;
    --default-font-size-lg:3.6rem;

    --text-big:6rem;

    --newstitle: 'Roboto Condensed', sans-serif;
    --newstext:'Overpass', sans-serif;

    /*GRID*/
    --grid-width: 114rem;
    --gutter-vertical: 8rem;
    --gutter-horizontal: 6rem;

    /*COLORS*/
    --Color-main-red-1:#e74c3c;
    --Color-main-red-2:#c0392b;

    --Color-main-gray-1: #ecf0f1;
    --Color-main-gray-2: #bdc3c7;
    --Color-main-gray-3: #7f8c8d;

    --Color-main-dark-1: #34495e;
    --Color-main-dark-2: #2c3e50;

    --Color-main-blue-1: #3498db;
    --Color-main-blue-2: #2980b9;

    --Color-main-green-1: #2ecc71;
    --Color-main-green-2: #27ae60;
  }

#app {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 0 0;
}

 
.information {
  margin-top: 100px;
  margin: auto;
  display: flex;
  flex-direction: column;
}
.well {
  background-color: rgb(191, 238, 229);
  margin: auto;
  padding: 50px 50px;
  ;
  border-radius: 20px;
  /* display:inline-block; */
}
.login {
  width: 200px;
  margin: auto;
}
.list-item:first-child {
  margin: 0;
}
.list-item {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.button {
  margin: auto;
}

</style>

